<template>
  <div class="height100-percent">
    <div class="table-page-search-wrapper bg-white">
      <a-form-model
        ref="fnForm"
        :model="baseInfo"
        :rules="rules"
        layout="inline"
        :labelCol="{ style: { width: '100px' } }"
      >
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-model-item label="月度计划名称" prop="monthPlanName">
              <a-input @input="baseInfo.monthPlanName = $event.target.value.replace(/\//g, '')" v-model="baseInfo.monthPlanName" />
            </a-form-model-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-model-item label="版本" prop="monthPlanVersion">
              <a-input :disabled="true" v-model="baseInfo.monthPlanVersion" />
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24"> </a-col>
        </a-row>
      </a-form-model>
    </div>

    <div
      :activeKey="activeTab"
      default-active-key="1"
      @change="tabsCallback"
      class="bg-white height100-percent mt5"
    >
      <div class="table-page-operator-wrapper toolbar bg-white">
        <a-button :loading="loading" @click="handleComfirmAndRun" type="primary" v-hasPermi="['scp:sopMonthPlan:saveAndCalculate']">确认并启动</a-button>
        <a-button :loading="loading" @click="handleSaveComfirm" type="primary">保存</a-button>

      </div>
      <div class="table-page-search-wrapper bg-white mr16">
        <a-form-model
          ref="basicForm"
          :model="baseInfo"
          :rules="basicRules"
          layout="inline"
          :labelCol="{ style: { width: '160px' } }"
        >
          <a-row>
            <a-col class="form-title" :md="24" :sm="24">
              <span class="form-title">计划期间</span>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="当前期间" prop="currentPeriod">
                <a-month-picker
                  disabled
                  class="w100-percent"
                  format="YYYY-MM"
                  valueFormat="YYYY-MM"
                  placeholder="请选择日期"
                  v-model="baseInfo.currentPeriod"
                >
                </a-month-picker>
              </a-form-model-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="计划期间" prop="forecastPeriodTem">
                <a-range-picker
                  :placeholder="['开始日期', '结束日期']"
                  valueFormat="YYYY-MM"
                  format="YYYY-MM"
                  :value="baseInfo.forecastPeriodTem"
                  :mode="mode"
                  @panelChange="handlePanelChange"
                />
              </a-form-model-item>
            </a-col>
            <!-- 第二行 -->
            <a-col class="form-title" :md="24" :sm="24">
              <span >计划参数</span>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="安全库存版本" prop="safeStockVersion">
                <global-select
                  searchParam="version"
                  :value.sync="baseInfo.safeStockVersion"
                  :setParams="formattedParams"
                  selectType="selectAssembleSearch"
                  :assembleLabelThrid="true"
                  requestApi="/scp/sopRatioHead/versionCodePullDown"
                  :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne' }"
                />
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24">
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="供应商产能版本" prop="vendorCapacityVersion">
                <global-select
                  :value.sync="baseInfo.vendorCapacityVersion"
                  selectType="selectAssembleSearch"
                  :setParams="formattedParams"
                  :assembleLabel="true"
                  requestApi="/scp/scpSopBasicData/versionList"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                />
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24">
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="发货预测版本" prop="sfcNameVersion">
                <global-select
                  searchParam="version"
                  :value.sync="baseInfo.sfcNameVersion"
                  selectType="selectAssembleSearch"
                  :assembleLabelThrid="true"
                  :setParams="{ monthStart: this.baseInfo.currentPeriod }"
                  requestApi="/scp/scpSopShipmentForecast/listShipmentForecastVersion"
                  :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne' }"
                />
              </a-form-model-item>
            </a-col>
            <a-col :md="16" :sm="24">
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import { ApiNewMonthPlan, ApiSaveAndCalculate } from '@/api/scp/month-plan/month-plan.js'
import moment from 'moment';
import { genType } from '@/api/system/codeconfig'

export default {
  // eslint-disable-next-line
  name: 'editPage', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
  components: {},
  data () {
    return {
      loading: false,
      businessList: [],
      baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
      orderId: '', // 单号Id（唯一码）
      activeTab: '1',
      rules: {
        monthPlanName: [{ required: true, message: '输入月度计划名称', trigger: 'submit' }]
      },
      basicRules: {
        safeStockVersion: [{ required: true, message: '输入安全库存版本', trigger: 'submit' }],
        vendorCapacityVersion: [{ required: true, message: '输入供应商产能版本', trigger: 'submit' }],
        sfcNameVersion: [{ required: true, message: '输入发货预测版本', trigger: 'submit' }],
        currentPeriod: [{ required: true, message: '输入当前期间', trigger: 'submit' }],
        forecastPeriodTem: [{ required: true, message: '输入预测期间', trigger: 'submit' }]
      },
      inventoryOrganizationCodeList: [], // 预测类型
      mode: ['month', 'month'],
      // 查询参数
      queryParams: {
        uomClassList: undefined
      },
      baseInfo: {
        monthPlanVersion: '', // 版本
        monthPlanName: '', // 名称
        currentPeriod: '', // 当前期间
        forecastPeriodTem: '', // 临时时间
        forecastPeriodFrom: '', // 预测期间起
        forecastPeriodTo: '', // 预测期间止
        safeStockVersion: '', // 安全库存版本
        vendorCapacityVersion: '', // 供应商产能
        sfcNameVersion: '', // 发货预测版本
        organizationCode: this.organizationCodeOrigin

      },
      // 表格配置
      yearMonthTem: null
    }
  },
  methods: {
    handlGselect (record, dataIndex) {
      if (dataIndex === 'forecastType') {
        record.forecastName = ''
      }
      record.listVersion = undefined
      record.version = undefined
    },
    tabsCallback (val) {
      this.activeTab = val
    },
    handleDel (record, index) {
      this.tableList.splice(index, 1)
    },
    handleAdd () {
      this.tableList.push({ ...this.tableListObj })
      this.$refs.dataTable.myDataSource = this.tableList
    },
    handleComfirmAndRun () {
      const self = this
      this.$confirm({
        title: '提示',
        content: '你确定确定并启动该记录吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.comfirmAndRun()
        },
        onCancel () {
        }
      });
    },
    async comfirmAndRun () {
      const promise1 = new Promise((resolve) => {
        this.$refs.fnForm.validate((valid) => {
          resolve(valid)
        })
      })

      const promise2 = new Promise((resolve) => {
        this.$refs.basicForm.validate((valid) => {
          resolve(valid)
        })
      })

      const [valid1, valid2] = await Promise.all([promise1, promise2])

      if (valid1 && valid2) {
      } else {
        this.$set(this, 'activeTab', '1')
        return ''
      }
      this.baseInfo.organizationCode = this.organizationCodeOrigin
      this.loading = true
      ApiSaveAndCalculate(this.baseInfo).then((response) => {
        this.loading = false
        if (response.code === 200) {
          this.$message.success('确认启动成功')
          this.event.$emit("close-current-page")
        } else {
          this.$message.error(response.msg)
        }
      }).catch(e => { this.loading = false })
      this.event.$emit("close-current-page")
    },
    handleSaveComfirm () {
      const self = this
      this.$confirm({
        title: '提示',
        content: '你确定保存该记录吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.handleSave()
        },
        onCancel () {
        }
      });
    },
    /** 保存数据到数据库 */
    async handleSave () {
      const promise1 = new Promise((resolve) => {
        this.$refs.fnForm.validate((valid) => {
          resolve(valid)
        })
      })

      const promise2 = new Promise((resolve) => {
        this.$refs.basicForm.validate((valid) => {
          resolve(valid)
        })
      })

      const [valid1, valid2] = await Promise.all([promise1, promise2])

      if (valid1 && valid2) {
      } else {
        return ''
      }
      this.baseInfo.organizationCode = this.organizationCodeOrigin
      this.loading = true
      ApiNewMonthPlan(this.baseInfo).then((response) => {
        this.loading = false
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.event.$emit("close-current-page")
        } else {
          this.$message.error(response.msg)
        }
      }).catch(e => { this.loading = false })
    },
    handlePanelChange (value, mode) {
      const yearMonth1 = value[0].format('YYYY-MM')
      let yearMonth2 = value[1].format('YYYY-MM')
      // if (yearMonth1 !== this.baseInfo.forecastPeriodFrom || yearMonth2 !== this.baseInfo.forecastPeriodTo) {
      //   this.baseInfo.vendorCapacityVersion = ''
      // this.baseInfo.safeStockVersion = ''
      // this.baseInfo.sfcNameVersion = ''
      // }
      if (this.yearMonthTem !== yearMonth1) {
        const yearAfter5MonthMoment = moment(yearMonth1, 'YYYY-MM').add(4, 'months');

        const yearAfter5Month = yearAfter5MonthMoment.format('YYYY-MM');
        yearMonth2 = yearAfter5Month
        value[1] = yearAfter5MonthMoment
      }
      this.baseInfo.forecastPeriodFrom = yearMonth1
      this.baseInfo.forecastPeriodTo = yearMonth2
      this.baseInfo.forecastPeriodTem = value
      this.yearMonthTem = yearMonth1
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams)
        .then()
        .then((response) => {
          this[arr] = response.rows
        })
    },
    addVersion () {
      const genParams = {
        codeName: '月度计划版本'
      }
      genType(genParams).then(response => {
      if (response.code === 200) {
          // const arr = JSON.parse(JSON.stringify(this.typeList))
          // const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
          // const obj = {
          //   versionCode: response.data, // 版本
          //   versionDescription: '', // 版本说明
          //   indexId: Number(indexId) + 1
          // }
          // arr.push(obj)
          // this.typeList = arr
          this.baseInfo.monthPlanVersion = response.data
        } else {
          this.$message.error(response.msg)
        }
      })
    }
  },

  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    // 其他计算属性
    // ...
    formattedParams () {
      return {
        monthStart: moment(this.baseInfo.currentPeriod).format("YYYYMM")
        // monthEnd: moment(this.baseInfo.forecastPeriodTo).format("YYYYMM")
      };
    }
  },
  activated () {
    this.baseInfo = {
        monthPlanVersion: '', // 版本
        monthPlanName: '', // 名称
        currentPeriod: '', // 当前期间
        forecastPeriodTem: '', // 临时时间
        forecastPeriodFrom: '', // 预测期间起
        forecastPeriodTo: '', // 预测期间止
        safeStockVersion: '', // 安全库存版本
        vendorCapacityVersion: '', // 供应商产能
        sfcNameVersion: '', // 发货预测版本
        organizationCode: this.organizationCodeOrigin
      }
    this.baseInfo.currentPeriod = moment().format('YYYY-MM');
    this.addVersion()
    },
  created () {
    this.baseInfo = {
        monthPlanVersion: '', // 版本
        monthPlanName: '', // 名称
        currentPeriod: '', // 当前期间
        forecastPeriodTem: '', // 临时时间
        forecastPeriodFrom: '', // 预测期间起
        forecastPeriodTo: '', // 预测期间止
        safeStockVersion: '', // 安全库存版本
        vendorCapacityVersion: '', // 供应商产能
        sfcNameVersion: '', // 发货预测版本
        organizationCode: this.organizationCodeOrigin
      }
    this.baseInfo.currentPeriod = moment().format('YYYY-MM');
    this.addVersion()
    },
  mounted () {
    // this.$refs.dataTable.myDataSource = this.tableList
  }
}
</script>
<style scoped lang="less">
.bg-white {
  background-color: white;
}
.toolbar {
  padding: 8px;
  display: flex;
  flex-direction: row;
  width: 100%;
}
.select-table {
  width: 180px;
}
a-input-number,
a-month-picker {
  width: 100%;
}
/deep/.ant-select {
  width: 100%;
}
.toRequired {
  color: #ff4949;
  padding-right: 2px;
}
.form-title{
  margin-left: 10px;
  margin-top: 15px;
}
.height100-percent {
  height: 100%
}
.mr16 {
  margin-right: 16px
}
.w100-percent {
  width: 100%;
}
.p8 {
  padding: 8px;
}
</style>
